import { ChangeDetectionStrategy, Component, Signal, computed, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';
import { IconName } from '@libs/shared/models';
import {
  TrackingDataFields,
  PageBlockImpressionDirective,
  provideContentTrackingData,
} from '@libs/shared/tracking';
import { HtmlDataLinkDirective } from '@libs/shared/ui';
import { ThemeColorName } from '@libs/themes';

@Component({
  selector: 'ui-info-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './info-bar.component.html',
  styleUrls: ['./info-bar.component.scss'],
  imports: [MatButtonModule, HtmlDataLinkDirective, IconComponent, PageBlockImpressionDirective],
  host: {
    '[class]': 'theme() ?? ""',
  },
  providers: [provideContentTrackingData(InfoBarComponent)],
})
export class InfoBarComponent {
  public closed: OutputEmitterRef<string> = output<string>();
  public uuid: InputSignal<string> = input('');
  public message: InputSignal<string> = input('');
  public showIconInfo: InputSignal<boolean> = input(true);
  public showIconClose: InputSignal<boolean> = input(true);
  public theme: InputSignal<ThemeColorName | undefined> = input();
  public data: InputSignal<TrackingDataFields> = input({});

  public icon: Signal<IconName | undefined> = computed<IconName | undefined>(
    () => {
      const showInfo: boolean = this.showIconInfo();
      const theme: ThemeColorName | undefined = this.theme();

      if (!showInfo || theme === undefined) {
        return undefined;
      }

      const themeIconMap: Partial<Record<ThemeColorName, IconName>> = {
        success: 'circle-check',
        error: 'triangle-exclamation',
        warning: 'triangle-exclamation',
        info: 'circle-info',
      };

      return themeIconMap[theme];
    },
  );

  public close(): void {
    const id: string = this.uuid();

    if (!id) {
      return;
    }

    this.closed.emit(id);
  }
}
